// modules
import { createAction } from 'redux-actions'

export const setUserProfile = createAction('SET_USER_PROFILE')
export const setIsUserAuthorized = createAction('SET_IS_USER_AUTHORIZED')
export const setIsManuallyLoggedOut = createAction(
  'SET_IS_USER_MANUALLY_LOGGED_OUT'
)
export const setUserGridSettings = createAction('SET_USER_GRID_SETTINGS')

export const deleteUserData = createAction('DELETE_USER_DATA')
